export default "__VITE_ASSET__BrheNEG4__"